<form [formGroup]="emailEditForm">
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="accountName" class="control-label required">{{ 'i18n.domain.settings.email-settings.account-name' | translate }}</label>
      <input id="accountName" type="text" class="form-control" formControlName="accountName" autocomplete="new-name"/>
      <app-error-messages [control]="formFields.accountName"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group" [ngClass]="{'col-md-6': isEditModeEqualsEntry, 'col-md-12': !isEditModeEqualsEntry}">
      <label for="accountType" class="control-label required">{{'i18n.domain.settings.email-settings.account-type' | translate}}</label>
      <ejs-dropdownlist [dataSource]="accountTypes"
                        [fields]="enumDropdownSettings"
                        id="accountType"
                        formControlName="accountType">
        <ng-template #itemTemplate let-data>
          {{data.text | translate}}
        </ng-template>
        <ng-template #valueTemplate let-data>
          <div class="centered">
            <span>{{data.text | translate}}</span>
          </div>
        </ng-template>
      </ejs-dropdownlist>
      <app-error-messages [control]="formFields.accountType"></app-error-messages>
    </div>
    <div class="form-group col-md-6" [hidden]="!isEditModeEqualsEntry">
      <label for="receiveOnlyMailsWithAttachments" class="control-label required">{{ 'i18n.domain.settings.email-settings.receive-only-mails-with-attachments' | translate }}</label>
      <app-yes-no-group-button id="receiveOnlyMailsWithAttachments" formControlName="receiveOnlyMailsWithAttachments"></app-yes-no-group-button>
    </div>
  </div>
  <hr>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="emailAddress" class="control-label required">{{ 'i18n.domain.settings.email-settings.email-address' | translate }}</label>
      <input id="emailAddress" type="text" class="form-control" formControlName="emailAddress" />
      <app-error-messages [control]="formFields.emailAddress"></app-error-messages>
    </div>
  </div>
  <hr>

  <div class="form-row row" [hidden]="formFields.accountType.value === EmailAccountType.Office365">
    <div class="form-group col-md-12">
      <label for="userName" class="control-label required">{{ 'i18n.domain.settings.email-settings.username' | translate }}</label>
      <input id="userName" type="text" class="form-control" formControlName="userName" />
      <app-error-messages [control]="formFields.userName"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="formFields.accountType.value === EmailAccountType.Office365">
    <div class="form-group col-md-12">
      <label for="password" class="control-label required">{{ 'i18n.domain.settings.email-settings.password' | translate }}</label>
      <input id="password" type="password" class="form-control" formControlName="password" appPasswordVisibility autocomplete="new-password"/>
      <app-error-messages [control]="formFields.password"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="formFields.accountType.value === EmailAccountType.Office365">
    <div class="form-group col-md-12">
      <label for="serverUrl" class="control-label required">{{ 'i18n.domain.settings.email-settings.server-url' | translate }}</label>
      <input id="serverUrl" type="text" class="form-control" formControlName="serverUrl" />
      <app-error-messages [control]="formFields.serverUrl"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="formFields.accountType.value === EmailAccountType.Office365">
    <div class="form-group col-md-6">
      @if (formFields.accountType.value === EmailAccountType.SMTP) {
        <label for="useSSL" class="control-label required">{{'i18n.domain.settings.email-settings.start-tls' | translate }}</label>
      }
      @if (formFields.accountType.value !== EmailAccountType.SMTP) {
        <label for="useSSL" class="control-label required">{{'i18n.domain.settings.email-settings.ssl' | translate }}</label>
      }
      <app-yes-no-group-button id="useSSL" formControlName="useSSL"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-6">
      <label for="port" class="control-label required">{{ 'i18n.domain.settings.email-settings.port' | translate }}</label>
      <input id="port" type="number" class="form-control" formControlName="port" />
      <app-error-messages [control]="formFields.port"></app-error-messages>
    </div>
  </div>

  <div class="form-row row" [hidden]="formFields.accountType.value !== EmailAccountType.Office365">
    <div class="form-group col-md-12">
      <label for="azureClientId" class="control-label required">{{ 'i18n.domain.settings.email-settings.azure-client-id' | translate }}</label>
      <input id="azureClientId" type="text" class="form-control" formControlName="azureClientId" />
      <app-error-messages [control]="formFields.azureClientId"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="formFields.accountType.value !== EmailAccountType.Office365">
    <div class="form-group col-md-12">
      <label for="azureClientSecret" class="control-label required">{{ 'i18n.domain.settings.email-settings.azure-client-secret' | translate }}</label>
      <input id="azureClientSecret" type="password" class="form-control" formControlName="azureClientSecret" appPasswordVisibility autocomplete="new-password"/>
      <app-error-messages [control]="formFields.azureClientSecret"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="formFields.accountType.value !== EmailAccountType.Office365">
    <div class="form-group col-md-12">
      <label for="azureTenantId" class="control-label required">{{ 'i18n.domain.settings.email-settings.azure-tenant-id' | translate }}</label>
      <input id="azureTenantId" type="text" class="form-control" formControlName="azureTenantId" />
      <app-error-messages [control]="formFields.azureTenantId"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="!isEditModeEqualsEntry">
    <div class="form-group col-md-12">
      <label for="archiveFolderName" class="control-label">{{ 'i18n.domain.settings.email-settings.arhive-folder' | translate }}</label>
      <ejs-tooltip id='tooltip' content="{{ 'i18n.domain.settings.email-settings.arhive-folder-hint' | translate }}">
        <span class="icon-information px-1"></span>
      </ejs-tooltip>
      <input id="archiveFolderName" type="text" class="form-control" formControlName="archiveFolderName" maxlength="20" />
      <app-error-messages [control]="formFields.archiveFolderName"></app-error-messages>
    </div>
  </div>
</form>
<form [formGroup]="emailTestForm" [hidden]="isEditModeEqualsEntry">
  <hr>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <div class="e-dlg-header">{{'i18n.domain.settings.email-settings.send-test-email-title' | translate}}</div>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-10">
      <label for="emailTestAddress" class="control-label">{{ 'i18n.domain.settings.email-settings.test-email-address' | translate }}</label>
      <input id="emailTestAddress" type="text" class="form-control" formControlName="emailTestAddress" />
      <app-error-messages [control]="emailTestForm.controls.emailTestAddress"></app-error-messages>
    </div>
    <div class="form-group col-md-2 align-bottom">
      <button class="btn btn-secondary test-btn" [disabled]="!emailEditForm.valid || !emailTestForm.valid || isTestRunning" (click)="sendTestEmail()">{{ 'i18n.domain.settings.email-settings.send-test-email' | translate }}</button>
    </div>
  </div>
</form>
<hr>
<div>
  <div class="form-row row">
    @if (formFields.exportInterfaceConfigurationInfos.value.length > 0) {
      <div class="form-group col-6">
        <div>{{ 'i18n.domain.settings.email-settings.used-in-export-configurations' | translate }}:</div>
        <ul>
          @for (exportConfiguration of formFields.exportInterfaceConfigurationInfos.value; track exportConfiguration) {
            <li><a (click)="onExportConfigLinkClicked(exportConfiguration)">{{exportConfiguration.name}}</a></li>
          }
        </ul>
      </div>
    }
    @if (formFields.exportInterfaceConfigurationTemplateInfos.value.length > 0) {
      <div class="form-group col-6">
        <div>{{ 'i18n.domain.settings.email-settings.used-in-export-config-templates' | translate }}:</div>
        <ul>
          @for (exportConfigTemplate of formFields.exportInterfaceConfigurationTemplateInfos.value; track exportConfigTemplate) {
            <li><a (click)="onExportConfigTemplateLinkClicked(exportConfigTemplate)">{{exportConfigTemplate.name}}</a></li>
          }
        </ul>
      </div>
    }
    @if (formFields.exportInterfaceActivationEmailTemplateInfos.value.length > 0) {
      <div class="form-group col-6">
        <div>{{ 'i18n.domain.settings.email-settings.used-in-activation-email-templates' | translate }}:</div>
        <ul>
          @for (activationEmailTemplate of formFields.exportInterfaceActivationEmailTemplateInfos.value; track activationEmailTemplate) {
            <li><a (click)="onExportConfigActivationEmailTemplateLinkClicked(activationEmailTemplate)">{{activationEmailTemplate.name}}</a></li>
          }
        </ul>
      </div>
    }
    @if (formFields.importConfigurationInfos.value.length > 0) {
      <div class="form-group col-6">
        <div>{{ 'i18n.domain.settings.email-settings.used-in-import-config' | translate }}:</div>
        <ul>
          @for (importConfiguration of formFields.importConfigurationInfos.value; track importConfiguration) {
            <li><a (click)="onImportConfigLinkClicked(importConfiguration)">{{importConfiguration.name}}</a></li>
          }
        </ul>
      </div>
    }
  </div>
</div>
